(function () {
  var u = "customerAODA";
  var d = "alectrautilities";
  var t = "com";
  var full = "";
  var target = document.getElementsByClassName("secure-contact")[0];
  if (target) {
    target.innerHTML = 'Email: <a href="#">' + full + "</a>";
  }
})();
